import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  warehouse: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  warehouse: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
};

export const { actions: regionActions, reducer: regionReducer } = createSlice({
  name: 'region',
  initialState,
  reducers: {
    //Request
    setRegionRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setRegionRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setRegionRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setRegionRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setRegionListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setRegionListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setRegionListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setRegionListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setRegionOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setRegionOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setRegionOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setRegionOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    //Warehouse
    setRegionWarehouseRequest: (state) => {
      state.warehouse = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setRegionWarehouseSuccess: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setRegionWarehouseFailure: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setRegionWarehouseDefault: (state) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
  },
});
